export const VEHICLE_IDENTITY_REQUIRED_MESSAGE =
  "A license plate or VIN is required." as const;

export function isVehicleIdentityRequiredError(
  plateMessage?: string,
  vinMessage?: string,
): boolean {
  return (
    plateMessage === VEHICLE_IDENTITY_REQUIRED_MESSAGE &&
    vinMessage === VEHICLE_IDENTITY_REQUIRED_MESSAGE
  );
}

export function hasVehicleIdentityField(values: {
  plate?: string | null;
  vin?: string | null;
}): boolean {
  return Boolean(values.plate?.trim()) || Boolean(values.vin?.trim());
}

/** Backend stores VIN-only creates as `VIN{vin}` in `plate`. */
export function isSyntheticVinPlate(
  plate: string | null | undefined,
  vin: string | null | undefined,
): boolean {
  const normalizedVin = vin?.trim();
  const normalizedPlate = plate?.trim();
  if (!normalizedVin || !normalizedPlate) return false;
  return normalizedPlate.toUpperCase() === `VIN${normalizedVin.toUpperCase()}`;
}

export function hasDisplayablePlate(vehicle: {
  plate?: string | null;
  vin?: string | null;
}): boolean {
  const plate = vehicle.plate?.trim();
  if (!plate) return false;
  return !isSyntheticVinPlate(plate, vehicle.vin);
}

export type VehicleIdentityDisplay =
  | {kind: "plate"; value: string}
  | {kind: "vin"; value: string};

export function getVehicleIdentityDisplay(vehicle: {
  plate?: string | null;
  vin?: string | null;
}): VehicleIdentityDisplay | null {
  if (hasDisplayablePlate(vehicle)) {
    return {kind: "plate", value: vehicle.plate!.trim()};
  }
  const vin = vehicle.vin?.trim();
  if (vin) return {kind: "vin", value: vin};
  const plate = vehicle.plate?.trim();
  if (plate) return {kind: "plate", value: plate};
  return null;
}

export function getVehicleIdentityTitle(vehicle: {
  plate?: string | null;
  vin?: string | null;
  vehicle_id?: number;
}): string {
  const identity = getVehicleIdentityDisplay(vehicle);
  if (identity) return identity.value;
  if (vehicle.vehicle_id != null) return `Vehicle #${vehicle.vehicle_id}`;
  return "Vehicle";
}
